// Feature flag of whether to show blocked/snoozed interactions or not.
export const SHOW_BLOCKED = false;
